const scrollToElement = (element) => animateToElement(jQuery(element).get(0).offsetTop);

const scrollToElementOnLoad = () => {
  if (window.location.hash && isDisclosureAccepted()) {
    const target = jQuery(window.location.hash);
    setTimeout(function () {
      if (target.length) {
        const top = target.get(0).offsetTop - jQuery('#header').height();
        animateToElement(top);
      }
    }, 500);
  }
};

const animateToElement = (top) => {
  jQuery('html, body').stop().animate(
    {
      scrollTop: top,
    },
    'fast',
    'swing',
  );
};

const isDisclosureAccepted = () => {
  return decodeURIComponent(document.cookie).indexOf('disclosure_accepted_domain_id') >= 0;
};

export { scrollToElement, scrollToElementOnLoad };
